import React, { useEffect, useState } from 'react'
import { ResourceType, Section, Fragment, SubSection } from '../../../interfaces/Publication';
import LeftMenuResource from './LeftMenuResource';
import resourceTypes from '../../../interfaces/ResourceTypes';


interface LeftMenuResourcesProps {
    sections: Section[]
    showLengthResources?: boolean;
    navigate?: boolean;
    showAloneTypeResource?: boolean;
}

const LeftMenuResources = ({sections, showLengthResources = true, navigate = true, showAloneTypeResource = false}: LeftMenuResourcesProps) => {


    return (
        <>
            {
                resourceTypes.map( (resourceType, index) =>(
                    <LeftMenuResource
                        key = {index}
                        sections = {sections}
                        resourceType = {resourceType}
                        showLengthResources={showLengthResources}
                        navigate={navigate}
                        showAloneTypeResource={showAloneTypeResource}
                    ></LeftMenuResource>
                ) )
            }
        </>
    )
}

export default LeftMenuResources
